import React, {useState} from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {getContentType} from 'app/utils/content-type';
import {getTemplateName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {TransferTemplateModal} from './TransferTemplateModal';

import {TemplateSerializedType} from 'sweet-types';

interface Props {
  template: TemplateSerializedType;
}

export function TransferTemplateButton({template}: Props) {
  const [showTransferTemplateModal, setShowTransferModal] =
    useState<boolean>(false);

  const documentCt = getContentType(template.document_content_type);

  return (
    <>
      <LazyTooltip tooltip={gt('Create a document based on this template')}>
        <button
          className="btn btn-primary"
          onClick={() => setShowTransferModal(true)}
        >
          {gt('Use this template')}
        </button>
      </LazyTooltip>
      <TransferTemplateModal
        templateName={getTemplateName(template)}
        templateURL={template.url}
        isOpen={showTransferTemplateModal}
        icon={documentCt.icon}
        onClose={() => setShowTransferModal(false)}
      />
    </>
  );
}
